import { render } from "./BoschungSaobracaj.vue?vue&type=template&id=aed30c3a&scoped=true"
import script from "./BoschungSaobracaj.vue?vue&type=script&lang=js"
export * from "./BoschungSaobracaj.vue?vue&type=script&lang=js"

import "./BoschungSaobracaj.vue?vue&type=style&index=0&id=aed30c3a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aed30c3a"]])

export default __exports__